import RichtextAdapter from "./RichtextAdapter";

export default RichtextAdapter;
export type { RichtextAdapterProps } from "./RichtextAdapter.d";
